import { format, parseISO } from "date-fns";
import { GridCellParams } from "@mui/x-data-grid";
import { useIntl } from "react-intl";

import { humanReadableDateTimeFormat } from "@dzambalaorg/constants";
import { AddressLink } from "@dzambalaorg/mui-scanner";

// prettier-ignore
export const referralTreeColumnsCreator = (formatMessage: ReturnType<typeof useIntl>["formatMessage"]) =>  [
  {
    field: "id",
    headerName: formatMessage({ id: "form.labels.id" }),
    sortable: true,
    flex: 0.05
  },
  {
    field: "wallet",
    headerName: formatMessage({ id: "form.labels.wallet" }),
    sortable: false,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} />
      );
    },
    flex: 1.5,
    minWidth: 150
  },
  {
    field: "referral",
    headerName: formatMessage({ id: "form.labels.referrer" }),
    sortable: false,
    renderCell: (params: GridCellParams<any, string>) => {
      return (
        <AddressLink address={params.value} />
      );
    },
    flex: 1.5,
    minWidth: 150
  },
  {
    field: "level",
    headerName: formatMessage({ id: "form.labels.level" }),
    sortable: true,
    flex: 0.3,
  },
];
